// src/components/GTMProvider.tsx

import { useEffect } from 'react';
import { gtmService } from '@/services/retargeting/gtm.service';

/**
 * GTMProvider Component (Google Ads Tracking)
 * Initializes Google Ads conversion tracking on app mount
 * Should be placed near the root of your app
 */
export const GTMProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useEffect(() => {
        gtmService.initialize();

        const trackPageView = () => {
            const maxAttempts = 10;
            let attempts = 0;

            const tryTrack = () => {
                attempts++;
                if (gtmService.isReady()) {
                    gtmService.trackPageView();
                } else if (attempts < maxAttempts) {
                    setTimeout(tryTrack, 500);
                } else {
                    gtmService.trackPageView();
                }
            };

            setTimeout(tryTrack, 100);
        };

        trackPageView();
    }, []);

    return <>{children}</>;
};